import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class BikeService {

    list: any = [];
    current: any = {};

    constructor(public apiService: ApiService, private router:Router) {

    }

    getList(page:number, limit:number){
        this.apiService.get('bikes', 'skip=' + page + '&limit=' + limit).subscribe(res=> {
            res.data.forEach(e => {
                 this.list.push(e);
            });
        }, (_err) => {
            this.apiService.error(_err);
        });
    }

    get(id:string){
        this.apiService.get('bike/'+id, '').subscribe(res=> {
            this.current = res.data;
        }, (_err) => {
            this.apiService.error(_err);
        });
    }

    LoadClientFromBike(customerList:any, bike:any, privateId: string) {
        this.apiService.get('clientFromBike', 'privateId=' + privateId).subscribe(res=> {
            if (customerList.length)
                customerList.length = 0;
            if (res.data.clients.length > 0) {
                res.data.clients.forEach((d)=> {
                    customerList.push(d);
                });
            }
            bike.brand = res.data.brand.toString();
            bike.model = res.data.model.toString();
        }, (_err) => {
            this.apiService.error(_err);
            this.router.navigate(['/']);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/bike.service.ts